<div class="container-fluid myClaimsHeader">
    <div class="content-width">
        <h1 class="pageHeader">{{title}}</h1>
        
      
                        
    </div>    
</div>